export const API_PATH_apiGeoPointElevationsGet = "/services/geo/apiGeoPointElevationsGet";
